import React from 'react'
import { useNote } from 'hooks/notes';
import { useParams } from 'react-router-dom'
import NewComment from './NewComment';
import 'stylesheets/MainAppStyles/Comments.css'
import CommentList from './CommentList';
import Note from 'components/MainApp/Notes/Note';


const Comments = () => {
    const { id } = useParams();
    const { note, isLoading: useNoteLoading } = useNote(id)

    if (useNoteLoading) return "Loading useNote..."

    return (
        <>
            <Note note={note} />
            <NewComment note={note} />
            <CommentList note={note} />
        </>
    )
}

export default Comments